import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { PropertyDataPickerComponent } from './property-data-picker.component';

@NgModule({
  declarations: [
    PropertyDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    PropertyDataPickerComponent
  ]
})
export class PropertyDataPickerModule { }
